// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"bed9e99c","423":"741d21f0","496":"4bffe0d1","626":"bdedb85a","732":"930be875","767":"81fd1c7b","835":"28c2218c","884":"960365f8","911":"c058e7ba"}[chunkId] + ".chunk.js";
};